import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';

import { booleanInputHandler } from './input.helpers';

const ToggleSwitchWidget = props => {
	const { onChange, value, ...otherProps } = props;
	const handler = booleanInputHandler(onChange);
	return (
		<Switch
			classes={{
				switchBase: 'toggle-switch-widget',
			}}
			disableRipple
			color="primary"
			checked={value}
			onChange={handler}
			{...otherProps}
		/>
	);
};

ToggleSwitchWidget.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
};

export default ToggleSwitchWidget;
